// price format
export function priceFromat(angka, prefix) {
  var numberString = angka.toString().replace(/[^,\d]/g, ''),
  split = numberString.split(','),
  sisa = split[0].length % 3,
  rupiah = split[0].substr(0, sisa),
  ribuan = split[0].substr(sisa).match(/\d{3}/gi)
  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if(ribuan){
    var separator = sisa ? '.' : ''
    rupiah += separator + ribuan.join('.')
  }
  rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah
  return prefix === undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
}

// gdrive format
export function getGdriveView(url) {
  const gdrive = 'https://docs.google.com/gview';
  return gdrive + '?url=' + url + '&embedded=true';
}

// duration job
export function durationJob(d1, d2, ispre) {
  const today = new Date();
  const day1 = new Date(d1);
  var day2 = new Date(d2);
  if (ispre === 'true' || JSON.parse(ispre) === true) {
    day2 = today;
  }
  var time = (day2.getTime() - day1.getTime()) / 1000;
  var year  = Math.abs(Math.round((time/(60 * 60 * 24))/365.25));
  var month = Math.abs(Math.round(time/(60 * 60 * 24 * 7 * 4)));
  month = month - (year * 12);
  var message = year + ' years ' + month + ' months';
  if (year <= 0) {
    message = month + ' months';
  }
  return message;
}

// get tahun angkatan
export function tahunAngkatan() {
  var angkatan = [];
  const range = 2;
  const currentYear = new Date().getFullYear();
  for (let i = 1; i <= range; i++) {
    let strangkatan = (currentYear - i + 1) + '-' + (currentYear - i + 2);
    angkatan.push(strangkatan);
  }
  return angkatan;
}